import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classnames from 'classnames';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import { IconButton } from '@material-ui/core';

const styles = (theme) => ({
  root: {},
  hoverMenuButton: {
    borderRadius: 0,
    padding: theme.spacing(0.5, 1),
    color: theme.palette.facet.primaryGray,
    height: '100%',
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.facet.darkGray,
      backgroundColor: theme.palette.facet.lightGray,
    },
  },
});

const HoverMenuItem = ({
  classes,
  className,
  isVisible,
  onClick,
  icon,
  toolTipTitle,
  test,
  disbaled,
}) => {
  const handleHoverMenuItemOnClick = event => {
    event.stopPropagation(); // <--- Prevents click-through propogation
    onClick();
  };

  const Icon = icon;

  return (
    <div
      className={classnames(classes.root, className)}
    >
      {isVisible && (
        <Tooltip
          placement="top"
          title={toolTipTitle}
        >
          <IconButton
            className={classes.hoverMenuButton}
            onClick={event => handleHoverMenuItemOnClick(event)}
            test={test}
            disbaled={disbaled}
          >
            <Icon />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

HoverMenuItem.defaultProps = {
  className: '',
  test: null,
  disbaled: false,
};

HoverMenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  toolTipTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  disbaled: PropTypes.bool,
  test: PropTypes.string,
};

export default withStyles(styles)(HoverMenuItem);
